<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" />
    <div class="mt-header-nav">
      <DataList api="News_List" :params="MenuName">
        <template v-slot:item="item">
          <news-card :data="item.obj" @click="toInfo(item.obj)" />
        </template>
      </DataList>
    </div>
  </div>
</template>

<script>
import DataList from "@/components/DataList";
import NewsCard from "@/components/NewsCard";

export default {
  components: {
    DataList,
    NewsCard
  },
  data() {
    return {
      info: {},
      MenuName: {},
      title: ""
    };
  },
  created() {
    let params = window.location;
    if (
      this.GetRequest(params.href) == undefined ||
      !this.GetRequest(params.href)
    ) {
      this.MenuName = { MenuName: "医院新闻" };
      document.getElementsByTagName("title")[0].innerText = "医院新闻";
      this.title = "医院新闻";
    } else if (this.GetRequest(params.href).menuName == "健康教育") {
      this.MenuName = { MenuName: this.GetRequest(params.href).menuName };
      document.getElementsByTagName("title")[0].innerText = this.GetRequest(
        params.href
      ).menuName;
      this.title = this.GetRequest(params.href).menuName;
    } else {
      this.MenuName = { MenuName: "医院新闻" };
      document.getElementsByTagName("title")[0].innerText = "医院新闻";
      this.title = "医院新闻";
    }

    // console.log(document.getElementsByTagName("title")[0].innerText);
  },
  methods: {
    toInfo(item) {
      this.$router.push({
        name: "hospitalNewsInfo",
        query: {
          Id: item.id
        }
      });
    },
    GetRequest() {
      var url = decodeURI(decodeURI(location.search)); //获取url中"?"符后的字串，使用两次decodeRUI解码
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        str = str.split("&");
        for (var i = 0; i < str.length; i++) {
          theRequest[str[i].split("=")[0]] = unescape(str[i].split("=")[1]);
        }
        return theRequest;
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
